/**
 *
 * @param {*} response
 * @param {*} customFilename 自定义文件名，只是一个备选
 */
export default function convertRes2Blob(response, customFilename) {
  // 提取文件名
  let filename = customFilename,
    type = "application/octet-stream";
  // content-type

  // 从头文件获取文件名，不然使用自定义的
  if (response.headers["content-disposition"]) {
    filename = response.headers["content-disposition"].match(
      /filename=(.*)/
    )[1];
  }

  // 文件类型
  if (response.headers["content-type"]) {
    type = response.headers["content-type"];
  }

  // 将二进制流转为blob
  const blob = new Blob([response.data], { type: type });
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(filename));
    // window.navigator.msSaveBlob(blob, filename);
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob);
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement("a");

    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", decodeURI(filename));
    // tempLink.setAttribute("download", filename);
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    // 挂载a标签
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL);
  }
}
